/**
 * @desc 根据ID查询用户领用详情
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.LabourDetailRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.LabourDetailDTO>>> {
  return defHttp.post({
    url: '/web/labour/queryDetail',
    data,
  });
}

export function mock(
  data: defs.LabourDetailRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.LabourDetailDTO>>> {
  return defHttp.post({
    url: '/mock/web/labour/queryDetail',
    data,
  });
}
